import http from "../http";
const ProjectsService = {
    getProjectsService: async () => {
        const projects = await http.instance.get("/projects");
        return projects.data
    },
    getProjectService: async (payload) => {
        const project = await http.instance.get("/projects/" + payload);
        return project.data[0];
    },
    getUserProjectService: async (payload) => {
        const userproject = await http.instance.get("/projects/AssignedUsers/" + payload);
        return userproject.data;
    },
    getProjectsOfUserService: async () => {
        const projectsuser = await http.instance.get("/projects/projectsofuser");
        return projectsuser.data;
    },
    addUserProjectService: async (form) => {
        const adduserproject = await http.instance.post("/projects/UserAssign/", form);

        return adduserproject.data;
    },
    addProjectService: async (form) => {
        const project = await http.instance.post("/projects/addproject", form);
        return project.data;
    },
    uploadIconService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
        const icon = await http.instance.post("projects/uploadicon", Files,{
            headers: {'Content-Type': 'multipart/form-data'},
            params: {}
        });
        return icon;
    },


    /**
     deleteUserService: async (idUser, idProject) => {
        const deleteuser = await http.instance.post("projects/deleteuser/", {
            params: {userId: idUser, projectId: idProject}
        });
        return deleteuser.data;
    },**/

    /*
    deleteUserService: async (userId, projectId) => {
        const deleteuser = await http.instance.post("projects/deleteuser/", + userId + "/" + projectId);
        return deleteuser.data;
    }*/

    deleteUserService: async (userId, projectId) => {
        let url = "projects/deleteuser/" + userId + "/" + projectId;
        const deleteuser = await http.instance.post(url);
        return deleteuser.data;
    }

    /*   addUserProjectService: async (idUser, idProject) => {
           const adduserproject = await http.instance.post("/projects/UserAssign/",
               {
                   params: {userId: idUser, projectId: idProject}
               })

           return adduserproject.data;
       }*/

};
export default ProjectsService;
